<template>

  <div class="section d-flex">

    <div class="menu_section hidden-md-and-down"></div>
    <div class="container_section">

      <v-container>

        <v-breadcrumbs :items="breadcrumbs" class="pl-0 pb-0"></v-breadcrumbs>

        <h1 class="py-10">Reporters</h1>

        <ReportersComponent />

      </v-container>

    </div>
    
  </div>

</template>

<script>

// import { mapGetters } from "vuex";
import ReportersComponent from '@/components/reporters/Reporters' ;

export default {
  name: "Reporters",

//   computed: {

//     ...mapGetters({
//       user: 'user/current'
//     })

//   },
  components: {
    ReportersComponent,
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: false,
          to: '/dashboard',
          exact: true
        },
        {
          text: 'Reporters',
          disabled: true,
          exact: true
        },
      ]
    }
  },
  methods: {

  },
  created() {

  }

};
</script>
